import WalletTypesPanel from './WalletTypesPanel';

export default WalletTypesPanel;
